module.exports = "<p>\n  <a [routerLink]=\"['/eventRegistration']\" routerLinkActive=\"active\">click</a>\n</p>\n"